/**
 * @name ratio
 */
export const ratio = (width: number, height: number): number => width / height;
